<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Application Price Update </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="refform">
            <div class="row d-flex justify-content-center">
                <div class="col-xl-12">
                    <!-- <button class="btn btn-secondary " (click)="refresh()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                    <app-button (refreshClicked)="refresh()"></app-button>
                </div>

                <div class="col-xl-4 my-2 d-flex padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                      <mat-label>Reference Number</mat-label>
                      <div class="search-input-container">
                        <input placeholder="Enter Reference Number" id="referenceno" matInput formControlName="referenceno"
                         type="text" #searchInput (keydown.enter)="search()">
                      </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                      (click)="search()">
                      <mat-icon style="color: white;">search</mat-icon>
                    </button>
                  </div>
                <div class="col-xl-2 my-2 mb-3" style="height: fit-content;align-self: end;">
                    <button class="btn reset_btn " (click)="searchreset()">
                        <i class="fa fa-refresh"></i> Reset
                    </button>
                </div>
            </div>
        </form>
        <div class="row justify-content-center mt-3" *ngIf="isform">
            <div class="container my-3">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Customer Details</span>
                    </div>
                </div>
                <form [formGroup]="cusform">

                    <div class="row mx-5 mt-2">

                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer</mat-label>
                                <input matInput appInputtext maxlength="25" formControlName="customername"
                                    class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>

                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Customer Number</mat-label>
                                <input matInput maxlength="25" formControlName="customernumber" class="col-10"
                                    autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mx-5 mt-3">

                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Reference Number</mat-label>
                                <input matInput maxlength="25" formControlName="applicationNumber" class="col-10"
                                    autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Product Recurring</mat-label>
                                <input matInput maxlength="25" formControlName="productrecurring" class="col-10"
                                    autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mx-5 mt-3">

                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Existing Monthly Fee</mat-label>
                                <input matInput maxlength="25" formControlName="monthlyfee" class="col-10"
                                    autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>New Monthly Fee</mat-label>
                                <input matInput maxlength="25" type="number" formControlName="newmonthlyfee"
                                    placeholder="Enter your New Monthly Fee" class="col-10" autocomplete="off"
                                    (input)="newmonthlyfee($event)">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mx-5 mt-3">
                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" style="width: 100%;" hideRequiredMarker>
                                <mat-label>New Product Name</mat-label>
                                <mat-select formControlName="newproduct" placeholder="Select new Product"
                                    (selectionChange)="onProductCategorySelect($event)">
                                    <input matInput placeholder="Search" />
                                    <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                        [label]="group?.categoryName?.toUpperCase()">
                                        <mat-option *ngFor="let product of group.products" [value]="product.id">
                                            {{ product?.aliasName?.toUpperCase() }}{{
                                            product?.productCategoryName?.toUpperCase() }}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-2">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Product Pricing</mat-label>
                                <input matInput maxlength="25" formControlName="productpricing" class="col-10"
                                    autocomplete="off">
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="row ml-1">
                        <div class="col-sm-12 col-md-6 mt-4" *ngIf="isbox">
                            <div class="col-sm-12 col-md-6 align-self-center"
                                style="display: flex; justify-content: space-between; align-items: center;">
                                <label style="margin-right: 30px; font-size: large;">Update Product/Price</label>
                                <mat-checkbox formControlName="isupdate" style="transform: scale(1.3);" color="primary"
                                    (change)="show($event.checked)"></mat-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center" *ngIf="data?.length > 0">
                        <div class="container my-4 mx-4">
                            <div class="table-responsive mt-2 ">
                                <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                                    <ng-container matColumnDef="customername">
                                        <mat-header-cell *matHeaderCellDef
                                            mat-sort-header="customername">Customer</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign"> {{dataField.customername}}</p>
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="customernumber">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="customernumber">Customer
                                            Nmber</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.customernumber}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="applicationNumber">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="applicationNumber">
                                            Reference Number</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.applicationNumber}} </p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="productrecurring">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="productrecurring">Product
                                            Recurring</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.productrecurring}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="monthlyfee">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="monthlyfee">Existing Monthly
                                            Fee</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.monthlyfee}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="newmonthlyfee">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="newmonthlyfee">New Monthly
                                            Fee</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <p class="text-truncate txtalign">{{dataField.newmonthlyfee}}</p>
                                        </mat-cell>
                                    </ng-container>
                                    <ng-container matColumnDef="isupdate">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header="isupdate">Update
                                            Product/Price</mat-header-cell>
                                        <mat-cell *matCellDef="let dataField">
                                            <div class="col-sm-12 col-md-6 align-self-center"
                                                style="display: flex; justify-content: space-between; align-items: center;">
                                                <mat-checkbox
                                                    (change)="show($event.checked,dataField)" style="transform: scale(1.3);"
                                                    color="primary"  [(ngModel)]="dataField.isupdate"  [ngModelOptions]="{standalone: true}">
                                                </mat-checkbox>
                                            </div>

                                        </mat-cell>

                                    </ng-container>
                                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                                    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                                    </mat-row>
                                </mat-table>
                            </div>
                            <div class="d-flex justify-content-end button-style mt-3">

                                <button class="btn btn-secondary mb-3" type="submit" (click)="onsubmit()"
                                    matButton>Save</button>
                            </div>
                        </div>
                    </div>
                </form>


            </div>
        </div>